import PropTypes from 'prop-types'
import Select from 'react-select'

import FormInput from './FormInput'

const SelectInput = ({
  columnSize,
  name,
  label,
  placeholder = '',
  options,
  value,
  setFieldValue,
  disabled,
}) => {
  return (
    <div className={`column is-${columnSize}`}>
      <FormInput label={label} name={name}>
        <Select
          className="select-container"
          classNamePrefix="select-primary"
          name={name}
          options={options}
          placeholder={placeholder || label}
          onChange={(e) => setFieldValue(name, e)}
          value={value}
          selectStyle={{ width: '100%' }}
          isDisabled={disabled}
        />
      </FormInput>
    </div>
  )
}

SelectInput.propTypes = {
  columnSize: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.array.isRequired,
  value: PropTypes.object,
  setFieldValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default SelectInput
